import {events} from '../events';

export const entitlementReducer = {
    [events.ENTITLEMENT_SET]: (state, {payload}) => ({
        ...state,
        ...payload
    })
};
